import { generateId } from '../../cross-app-shared/services/generate-id';
import { computed, markRaw, ref } from 'vue';
import { exposedPromise } from './utility';

export type ModalItem = {
  modalID: `modal_${string}`;
  component?: { content: any; bindings: Record<string, unknown>; resolve: (arg: any) => void };
  openedAt: number | null;
};
export const modalsRegistered = ref([] as ModalItem[]);
export const modalOnTop = computed(() => {
  return modalsRegistered.value.filter((m) => m.openedAt).sort((a, b) => b.openedAt! - a.openedAt!)[0]?.modalID || null;
});

export function modalRegister(): ModalItem['modalID'];
export function modalRegister(component: { content: any; bindings: Record<string, unknown> }): Promise<any>;
export function modalRegister(component?: {
  content: any;
  bindings: Record<string, unknown>;
}): ModalItem['modalID'] | Promise<any> {
  const newArr = modalsRegistered.value.slice();
  const modalID = generateId('modal');

  if (component) {
    const { promise, resolve } = exposedPromise();
    newArr.push({
      modalID,
      component: {
        content: markRaw(component.content),
        bindings: component.bindings,
        resolve,
      },
      openedAt: null,
    });
    modalsRegistered.value = newArr;
    return promise;
  } else {
    newArr.push({ modalID, component: component ? markRaw(component) : undefined, openedAt: null });
    modalsRegistered.value = newArr;
    return modalID;
  }
}

export function modalSetOpened(modalID: ModalItem['modalID'], isOpen: boolean) {
  const newArr = modalsRegistered.value.slice();
  const index = newArr.findIndex((m) => m.modalID === modalID);
  if (index !== -1) {
    newArr.splice(index, 1, { ...newArr[index], openedAt: isOpen ? Date.now() : null });
    modalsRegistered.value = newArr;
  }
}

export function modalRemove(modalID: ModalItem['modalID']) {
  const newArr = modalsRegistered.value.slice();
  const index = newArr.findIndex((m) => m.modalID === modalID);
  if (index !== -1) {
    newArr.splice(index, 1);
    modalsRegistered.value = newArr;
  }
}

export function modalsCloseGlobal() {
  for (const { modalID, component } of modalsRegistered.value) {
    if (component) {
      modalRemove(modalID);
    }
  }
}

export function modalCloseLastGlobal() {
  if (modalsRegistered.value.length > 0) {
    const last = modalsRegistered.value[modalsRegistered.value.length - 1];
    modalRemove(last.modalID);
  }
}
